import { axiosApi } from "../../../../../api/dbAxios";

export const updateDocumentInfo = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  fields: any,
) => {
  try {
    const response = await axiosApi.patch(
      `/items/${regulatorCode}/${case_no}/`,
      fields,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating document info:", error);
    return {};
  }
};
